import Shuttle from './Shuttle';

export default Shuttle;
